export default {
  methods: {
    getLayerById(id) {
      return this.map
        .getLayers()
        .getArray()
        .find((layer) => layer.get("layer_id") == id);
    },
  },
};